import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { ChevronsUpDown } from "lucide-react";

export function ProductCombobox({ products, label, onSelect, placeholder = "Search product…", testId = "product-combobox" }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox"
                className="mt-1 w-full h-9 justify-between font-normal text-left" data-testid={testId}>
          <span className={`truncate ${label ? "text-slate-800" : "text-slate-400"}`}>{label || placeholder}</span>
          <ChevronsUpDown size={13} className="opacity-50 shrink-0 ml-1" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[340px]" align="start">
        <Command>
          <CommandInput placeholder="Type to search products…" data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>No product found.</CommandEmpty>
            {products.map((p) => (
              <CommandItem key={p.id} value={`${p.description || ""} ${p.product_code || ""}`}
                           onSelect={() => { onSelect(p); setOpen(false); }}
                           data-testid={`${testId}-opt-${p.id}`}>
                <span className="truncate">{p.description || p.product_code}</span>
                <span className="ml-auto pl-2 text-[10px] text-slate-400 font-mono shrink-0">{p.product_code}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
